import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import stylesPc from "./EditVideo.module.css";
import stylesSp from "./EditVideo_SP.module.css";
import styleIpad from "./EditVideo_IP.module.css";
import { IsDevice } from "../../../components/function/useDeviceFlag";
import {
    Modal,
    TextField,
    Button,
    FormControl,
    MenuItem,
    Select,
    createStyles,
    makeStyles,
    Theme,
    Chip,
    ThemeProvider,
    createTheme,
    Fab,
    IconButton,
} from "@material-ui/core";
import { AppState } from "../../../root/RootReducer";
import EditIcon from "@material-ui/icons/Edit";
import { GetGroupList, GetUserInfoList } from "../../../user/UserActions";
import { Group } from "../../../user/User";
import { isAdmin, isEditor } from "../../../utils/LogicUtils";
import SelectTag from "../../../admin/viewer/SelectTag";
import {
    DeleteVideo,
    EditVideo,
    getTagList,
    ResetDuplicateError,
    ResetVideo,
} from "../../video/VideoActions";
import UploadDocument from "../../../pages/vod/Common/UploadDocument";
import OnLeaveDialog from "../dialog/OnLeaveDialog";
import { countCharLength } from "../../../utils/ValidationUtils";
import PuiMessage from "../../../components/widgets/PuiMessage";
import SelectGroup from "../../../pages/admin/EditUser/SelectGroup";
import { VideoExtraMaterial } from "../../video/models/VideoExtraMaterial";
import { ExtractExtention, GetTagIdFromTagName } from "../../../utils/ObjectUtils";
import PuiTypography from "../../../components/elements/PuiTypography";
import ClearIcon from "@material-ui/icons/Clear";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

interface EditVideoPageProps {
    // 編集したいビデオのid
    videoId: number;
    setEditModalOpen?: (target: boolean) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        title: {
            width: IsDevice("iphone") ? "100%" : "440px",
            background: "#FFFFFF0D",
            borderRadius: "5px",
            fontWeight: "bold",
            "& .MuiInputBase-root": {
                height: "40px",
                "& .MuiInputBase-input": {
                    border: "none",
                    color: "white",
                    fontFamily: "Yu Gothic",
                },
            },
        },
        formSelect: {
            border: "1px solid rgba(255, 255, 255, 0.3)",
            width: IsDevice("iphone") ? "100%" : "440px",
            height: "40px",
            fontSize: "14px",
            background: "#FFFFFF0D",
            borderRadius: "5px",
            fontFamily: "Yu Gothic",
            "& .MuiSelect-icon": {
                color: "white",
            },
            "& .MuiSelect-selectMenu": {
                color: "white",
            },
        },
        menuItem: {
            backgroundColor: "#323438",
            color: "rgba(255, 255, 255, 0.3)",
            "&:hover": {
                color: "rgba(255, 255, 255, 0.6)",
                backgroundColor: "rgba(1, 1, 1, 0.5)",
            },
            // "& .MuiButtonBase-root": {
            //     color: "rgba(1, 1, 1, 0.5)",
            // },
        },
        icon: {
            marginLeft: "5px",
            marginTop: "5px",
            backgroundColor: "rgb(255, 255, 255, 0.7)",
            "&:hover": {
                backgroundColor: "rgb(255, 255, 255, 0.9)",
            },
        },
        textField: {
            width: IsDevice("iphone") ? "100%" : "440px",
            minHeight: IsDevice("iphone") ? "none" : "200px",

            overflowY: "auto",
            background: "#FFFFFF0D",
            border: "none",
            borderRadius: "5px",
            "& .MuiInputBase-root": {
                minHeight: "200px",
                "& .MuiInputBase-input": {
                    height: "173px !important",
                    color: "white",
                    fontFamily: "Yu Gothic",
                },
            },
        },
    })
);

const theme = createTheme({
    palette: {
        secondary: {
            main: "#16ADC1",
        },
    },
});

function EditVideoPage({ videoId, setEditModalOpen }: EditVideoPageProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : IsDevice("ipad") ? styleIpad : stylesSp;

    const classes = useStyles();
    const history = useHistory();

    // ユーザー取得
    const { professionals, user, videos, isSuccessDeleteVideo, tags, groupList } = useSelector(
        (state: AppState) => ({
            professionals: state.user.userInfoList,
            user: state.user.user,
            videos: state.video.videos,
            isSuccessDeleteVideo: state.video.isSuccessDeleteVideo,
            tags: state.video.tags,
            groupList: state.user.groupList,
        })
    );

    const dispatch = useDispatch();
    const inputVideoRef = useRef<HTMLInputElement>(null);
    const inputImageRef = useRef<HTMLInputElement>(null);

    const handlePropagation = (event: React.MouseEvent) => {
        event.nativeEvent.stopImmediatePropagation();
    };

    // ビデオ編集モーダル画面表示制御
    const [isOpenEditVideoModal, ShowEditVideoModal] = useState(false);
    // 入力チェック
    const [isInputAllForm, CheckInputForm] = useState(false);

    // ビデオ編集モーダル表示
    const OpenEditVideoModal = () => {
        if (!videos || !videos[videoId]) return;

        dispatch(GetUserInfoList());
        dispatch(getTagList([]));
        ChangeAlreadyUploadDocumentList(videos[videoId].extraMaterials);
        InputVideoFile(null);
        if (inputVideoRef.current) {
            inputVideoRef.current.value = "";
        }
        ChangeTextVideoFile(videos[videoId].fileName);
        ChangePreviewImageFlag(1);
        InputImageUrl(videos[videoId].imageUrl);
        InputImageFile(null);
        if (inputImageRef.current) {
            inputImageRef.current.value = "";
        }
        ChangeTextImageFile("Imageファイルを選択してください");
        ChangeTitleValiFlag(false);
        InputVideoName(videos[videoId].title);
        ChangeDescriptionValiFlag(false);
        InputVideoDetail(videos[videoId].description);
        InputProId(videos[videoId].presenterId);
        setTagList(videos[videoId].tags);
        setGroup(videos[videoId].groupList ?? []);
        ShowEditVideoModal(true);
        if (setEditModalOpen) {
            setEditModalOpen(true);
        }
    };

    // ビデオ編集モーダル非表示
    const CloseEditVideoModal = () => {
        if (isSaved) {
            ShowEditVideoModal(false);
            if (setEditModalOpen) {
                setEditModalOpen(false);
            }
            // リセット処理
            InputVideoFile(null);
            if (inputVideoRef.current) {
                inputVideoRef.current.value = "";
            }
            ChangeTextVideoFile("");
            ChangePreviewImageFlag(1);
            InputImageUrl("");
            InputImageFile(null);
            if (inputImageRef.current) {
                inputImageRef.current.value = "";
            }
            ChangeTextImageFile("");
            ChangeTitleValiFlag(false);
            InputVideoName("");
            ChangeDescriptionValiFlag(false);
            InputVideoDetail("");
            ChangeAlreadyUploadDocumentList([]);
            ChangeDocumentList([]);
            ChangeDocumentNameList([]);
            InputProId("");
            setTagList([]);
            ShowTagSelectModal(false);
            ShowVerifyDeleteModal(false);
            CheckInputForm(false);
        } else {
            setOpenDialog(true);
        }
    };

    const [isErrorInputSize, ChangeErrorInputSize] = useState(false);
    // ファイルサイズエラーバー消去
    const CloseErrorInputBar = () => {
        ChangeErrorInputSize(false);
    };

    // ビデオファイル
    const [inputVideoFile, InputVideoFile] = useState(null);
    const [textVideoFile, ChangeTextVideoFile] = useState("");
    const [isLimitInputFileSize, ChangeLimitInputFileSize] = useState(false);

    // ファイルサイズ制限バー消去
    const CloseLimitInputFileBar = () => {
        ChangeLimitInputFileSize(false);
    };

    // サムネイル画像ファイル
    // 表示状態 1= defaultUrl 2= imageText 3= imageThumbnail
    const [visiblePreviewImage, ChangePreviewImageFlag] = useState(1);
    const [inputImageUrl, InputImageUrl] = useState("");
    const [inputImageFile, InputImageFile] = useState(null);
    const [textImageFile, ChangeTextImageFile] = useState("");
    const [isLimitInputImageSize, ChangeLimitInputImageSize] = useState(false);
    const ClickPreviewImage = (event: any) => {
        ChangeTextImageFile("");
        ChangePreviewImageFlag(2);
        InputImageUrl("");
        setIsSaved(false);
    };
    const UserUploadImage = (event: any) => {
        if (event.target.files.length === 0) {
            ChangeTextImageFile("アップロードするファイルを選択");
            InputImageFile(null);
            if (inputImageRef.current) {
                inputImageRef.current.value = "";
            }
        } else if (event.target.files.length === 1) {
            if (event.target.files[0].size > 0) {
                if (event.target.files[0].size > 10485760) {
                    ChangeLimitInputImageSize(true);
                } else {
                    ChangeTextImageFile(event.target.files[0].name);
                    InputImageFile(event.target.files[0]);
                    ChangePreviewImageFlag(3);
                    setIsSaved(false);
                }
            } else {
                ChangeErrorInputSize(true);
                if (inputImageRef.current) {
                    inputImageRef.current.value = "";
                }
            }
        } else {
            ChangeTextImageFile("ファイルを正しく選択してください");
            InputImageFile(null);
            if (inputImageRef.current) {
                inputImageRef.current.value = "";
            }
        }
    };

    // サムネイルサイズ制限バー消去
    const CloseLimitInputImageBar = () => {
        ChangeLimitInputImageSize(false);
    };

    // ビデオタイトル
    const [isErrorTitleVali, ChangeTitleValiFlag] = useState(false);
    const [inputVideoName, InputVideoName] = useState("");
    const ChangeTitle = (event: any) => {
        if (countCharLength(event.target.value) > 80) {
            InputVideoName(event.target.value);
            ChangeTitleValiFlag(true);
        } else {
            ChangeTitleValiFlag(false);
            InputVideoName(event.target.value);
        }
        setIsSaved(false);
    };

    // ビデオ要約
    const [isErrorDescriptionVali, ChangeDescriptionValiFlag] = useState(false);
    const [inputVideoDetail, InputVideoDetail] = useState("");
    const ChangeDescription = (event: any) => {
        if (countCharLength(event.target.value) > 400) {
            InputVideoDetail(event.target.value);
            ChangeDescriptionValiFlag(true);
        } else {
            ChangeDescriptionValiFlag(false);
            InputVideoDetail(event.target.value);
        }
        setIsSaved(false);
    };

    // 資料アップロード
    const [alreadyUploadDocumentList, ChangeAlreadyUploadDocumentList] = useState<
        VideoExtraMaterial[]
    >([]);
    const [documentList, ChangeDocumentList] = useState<File[]>([]);
    const [documentNameList, ChangeDocumentNameList] = useState<string[]>([]);
    const [isErrorDocumentListLength, ErrorDocumentListLength] = useState(false);

    // プロフェッショナル
    const [inputProId, InputProId] = useState("");
    const UserInputVideoProfessional = (event: any) => {
        InputProId(event.target.value);
        setIsSaved(false);
    };

    // タグ
    const [tagList, setTagList] = React.useState<string[]>([]);
    // タグ選択モーダル表示制御
    const [isOpenTagSelectModal, ShowTagSelectModal] = useState(false);
    // タグ選択モーダル表示
    const OpenTagSelectModal = () => {
        ShowTagSelectModal(true);
    };
    // タグ選択モーダル非表示
    const CloseTagSelectModal = () => {
        ShowTagSelectModal(false);
        dispatch(ResetDuplicateError());
    };
    // ユーザタグ消去
    const handleDelete = (tagName: string) => () => {
        setTagList((tagList) => tagList.filter((v) => v !== tagName));
        setIsSaved(false);
    };

    // ユーザキャンセルボタン押下
    const ClickCancelButton = () => {
        CloseEditVideoModal();
    };

    // ユーザ削除ボタン押下
    const ClickDeleteButton = () => {
        OpenVerifyDeleteModal();
    };

    // ユーザ編集完了ボタン押下
    const ClickConfirmButton = () => {
        if (visiblePreviewImage !== 1) {
            InputImageUrl("");
        }
        if (
            textVideoFile !== "Videoファイルを選択してください（1GBまで）" &&
            textVideoFile !== "ファイルを正しく選択してください（1GBまで）" &&
            inputVideoName !== "" &&
            inputVideoDetail !== "" &&
            isErrorTitleVali !== true &&
            isErrorDescriptionVali !== true &&
            !isErrorDocumentListLength
        ) {
            // if(user){
            //     dispatch(loadVideoStarted(videoId, user.id));
            // }
            const defaultMaterialIdList: number[] = [];
            videos[videoId].extraMaterials?.map(function (row) {
                defaultMaterialIdList.push(row.id);
                return null;
            });

            const materialIdList: number[] = [];
            alreadyUploadDocumentList?.map(function (row) {
                materialIdList.push(row.id);
                return null;
            });
            const sendMaterialIdList: number[] = defaultMaterialIdList.filter(
                (i) => materialIdList.indexOf(i) === -1
            );

            if (user) {
                dispatch(
                    EditVideo({
                        userId: user.id,
                        file: inputVideoFile,
                        imageFile: inputImageFile,
                        documentFile: documentList,
                        documentName: documentNameList,
                        materialId: sendMaterialIdList,
                        video: {
                            id: videoId,
                            title: inputVideoName,
                            description: inputVideoDetail,
                            imageUrl: inputImageUrl,
                            presenter: inputProId,
                            tags: GetTagIdFromTagName(tagList, tags),
                            group: group.map((group) => Number(group.id)),
                        },
                    })
                );
                CloseEditVideoModal();
            } else {
                CheckInputForm(true);
            }
        }
    };

    // ビデオ削除確認モーダル表示制御
    const [isOpenVerifyDeleteModal, ShowVerifyDeleteModal] = useState(false);
    // ビデオ削除確認モーダル表示
    const OpenVerifyDeleteModal = () => {
        ShowVerifyDeleteModal(true);
    };
    // ビデオ削除確認モーダル非表示
    const CloseVerifyDeleteModal = () => {
        ShowVerifyDeleteModal(false);
    };

    // ユーザ削除確認ボタン押下
    const ClickConfirmDeleteUserButton = () => {
        const type = ExtractExtention(videos[videoId].fileName).replace(/^./, "");
        CloseEditVideoModal();
        CloseVerifyDeleteModal();
        dispatch(DeleteVideo(videoId, type));
    };
    // ビデオ削除後、一覧画面に戻る
    useEffect(() => {
        if (isSuccessDeleteVideo) {
            history.push("/contents");
            dispatch(ResetVideo());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccessDeleteVideo]);

    useEffect(() => {
        if (groupList && groupList.length === 0) {
            dispatch(GetGroupList());
        }
        // eslint-disable-next-line
    }, []);

    // ユーザ削除キャンセルボタン押下
    const ClickCancelDeleteUserButton = () => {
        CloseVerifyDeleteModal();
    };

    // ユーザ入力保存確認
    const [isSaved, setIsSaved] = React.useState<boolean>(true);
    const [openDialog, setOpenDialog] = React.useState(false);

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleCancel = () => {
        handleCloseDialog();
    };

    const handleConfirm = () => {
        setIsSaved(true);
        handleCloseDialog();
        CloseEditVideoModal();
    };

    // グループ選択モーダル画面表示制御
    const [isOpenGroupSelectModal, ShowGroupSelectModal] = useState(false);
    const [group, setGroup] = useState<Group[]>([]);

    const CloseGroupSelectModal = () => {
        ShowGroupSelectModal(false);
        // ChangeEditUserGroup([]);
    };
    const SetVideoGroup = (updateGroupList: Group[]) => {
        setGroup(updateGroupList);
        setIsSaved(false);
    };

    // グループ選択
    const UserInputVideoGroup = (event: any) => {
        const groupNames: string[] = event.target.value;
        if (groupNames.includes("選択なし")) groupNames.splice(0, 1);
        const tempGroups: Group[] = [];
        groupList.forEach((group) => {
            if (groupNames.includes(group.title)) {
                tempGroups.push(group);
            }
        });
        setGroup(tempGroups);
        setIsSaved(false);
    };

    //Addアイコンにマウス入る処理
    const [isMouseEnterInfo, setMouseEnterInfo] = useState<boolean>(false);

    return (
        <div>
            {(isAdmin(user?.roles) || isEditor(user?.roles)) && (
                <div className={styles.menuArea} onClick={handlePropagation}>
                    <Fab
                        variant="circular"
                        size="small"
                        onClick={OpenEditVideoModal}
                        className={classes.icon}
                    >
                        <EditIcon style={{ color: "var(--button-bg)" }} />
                    </Fab>
                </div>
            )}
            {/* ビデオ編集モーダル */}
            <Modal
                open={isOpenEditVideoModal}
                onClose={CloseEditVideoModal}
                className={styles.editModal}
            >
                <div className={styles.modal}>
                    <IconButton onClick={ClickCancelButton}>
                        <ClearIcon
                            style={{
                                color: "#808080",
                                fontSize: "29px",
                                top: "calc(2.5% - 13px)",
                                right: "calc(1% - 0px)",
                                position: "fixed",
                            }}
                        />
                    </IconButton>
                    <ul className={styles.inputForm}>
                        <FormControl className={styles.formControl}>
                            <form name="addVideoForm">
                                {!IsDevice("desktop") && (
                                    <div
                                        onClick={CloseEditVideoModal}
                                        className={styles.closeButton}
                                    >
                                        <img
                                            src={require("../../../assets/image/closeFilter.svg")}
                                            alt="close"
                                        />
                                    </div>
                                )}
                                <ul>
                                    <div className={styles.titleText}>
                                        <PuiTypography size={18}>動画の編集</PuiTypography>
                                    </div>
                                    {/* タイトル */}
                                    <ThemeProvider theme={theme}>
                                        <li>
                                            <div className={styles.formHelperText}>タイトル</div>
                                            <div className={styles.form}>
                                                <TextField
                                                    color="secondary"
                                                    className={classes.title}
                                                    id="videoName"
                                                    variant="outlined"
                                                    placeholder="Videoタイトルを入力"
                                                    autoComplete="off"
                                                    value={inputVideoName}
                                                    onChange={ChangeTitle}
                                                    error={isErrorTitleVali}
                                                    helperText={
                                                        isErrorTitleVali &&
                                                        "全角40文字（半角80文字）以内で正しく入力してください"
                                                    }
                                                />
                                            </div>
                                        </li>

                                        {/* プロフェッショナル */}
                                        <li>
                                            <div className={styles.formHelperText}>
                                                プレゼンター
                                            </div>
                                            <div className={styles.form}>
                                                <>
                                                    <Select
                                                        required
                                                        color="secondary"
                                                        id="demo-simple-select"
                                                        variant="outlined"
                                                        onChange={UserInputVideoProfessional}
                                                        value={inputProId}
                                                        className={classes.formSelect}
                                                    >
                                                        {professionals !== undefined &&
                                                            professionals.length > 0 &&
                                                            professionals.map(
                                                                (row) =>
                                                                    row.roles.includes(
                                                                        "PRESENTER"
                                                                    ) && (
                                                                        <MenuItem
                                                                            key={row.id}
                                                                            value={row.id}
                                                                            className={
                                                                                classes.menuItem
                                                                            }
                                                                            style={{
                                                                                color:
                                                                                    inputProId ===
                                                                                    row.id
                                                                                        ? "rgba(1, 1, 1, 0.5)"
                                                                                        : "rgba(255, 255, 255, 0.6)",
                                                                            }}
                                                                        >
                                                                            {row.fullName}
                                                                        </MenuItem>
                                                                    )
                                                            )}
                                                    </Select>
                                                </>
                                            </div>
                                        </li>
                                        {/* グループ（モーダル表示） */}
                                        <li className={styles.mb50}>
                                            <div className={styles.formHelperTextLong}>
                                                グループ
                                            </div>
                                            <div className={styles.form}>
                                                <>
                                                    <Select
                                                        color="secondary"
                                                        id="group-select"
                                                        variant="outlined"
                                                        onChange={UserInputVideoGroup}
                                                        value={
                                                            group
                                                                ? group.map((group) => group.title)
                                                                : []
                                                        }
                                                        multiple
                                                        displayEmpty
                                                        renderValue={(selected: any) => {
                                                            if (selected.length === 0) {
                                                                return <em>選択なし</em>;
                                                            }

                                                            return selected.join(", ");
                                                        }}
                                                        MenuProps={{
                                                            getContentAnchorEl: null,
                                                            anchorOrigin: {
                                                                vertical: "top",
                                                                horizontal: "left",
                                                            },
                                                            transformOrigin: {
                                                                vertical: "top",
                                                                horizontal: "left",
                                                            },
                                                        }}
                                                        className={classes.formSelect}
                                                        style={{
                                                            maxHeight:
                                                                ITEM_HEIGHT * 4.5 +
                                                                ITEM_PADDING_TOP,
                                                        }}
                                                    >
                                                        <MenuItem disabled value="">
                                                            <em>選択なし</em>
                                                        </MenuItem>
                                                        {groupList &&
                                                            groupList.map((row) => (
                                                                <MenuItem
                                                                    key={row.id}
                                                                    value={row.title}
                                                                    className={classes.menuItem}
                                                                    style={{
                                                                        color: group
                                                                            ? group.some(
                                                                                  (group) =>
                                                                                      group.title ===
                                                                                      row.title
                                                                              )
                                                                                ? "#fff"
                                                                                : "rgba(255, 255, 255, 0.6)"
                                                                            : "rgba(255, 255, 255, 0.6)",
                                                                        background: group
                                                                            ? group.some(
                                                                                  (group) =>
                                                                                      group.title ===
                                                                                      row.title
                                                                              )
                                                                                ? "rgba(1, 1, 1, 0.5)"
                                                                                : ""
                                                                            : "",
                                                                    }}
                                                                >
                                                                    {row.title}
                                                                </MenuItem>
                                                            ))}
                                                    </Select>
                                                </>
                                            </div>
                                        </li>

                                        {/* 要約 */}
                                        <li>
                                            <div className={styles.formHelperTextLong}>内容</div>
                                            <div className={styles.form}>
                                                <TextField
                                                    color="secondary"
                                                    id="description"
                                                    onChange={ChangeDescription}
                                                    className={classes.textField}
                                                    multiline
                                                    minRows={5}
                                                    autoComplete="off"
                                                    value={inputVideoDetail}
                                                    variant="outlined"
                                                    placeholder="内容を入力してください"
                                                    error={isErrorDescriptionVali}
                                                    helperText={
                                                        isErrorDescriptionVali &&
                                                        "全角200文字（半角400文字）以内で正しく入力してください"
                                                    }
                                                />
                                            </div>
                                        </li>
                                    </ThemeProvider>

                                    {/* 画像サムネイルファイル */}
                                    <li>
                                        <div
                                            className={styles.formHelperText}
                                            style={{ marginTop: "0" }}
                                        >
                                            サムネイル
                                        </div>
                                        {visiblePreviewImage === 1 && (
                                            <>
                                                <div className={styles.formHelperImage}>
                                                    <div className={styles.changeThumbs}>
                                                        <div className={styles.previewImage}>
                                                            <img
                                                                alt="defaultThumbnail"
                                                                style={{ cursor: "pointer" }}
                                                                src={inputImageUrl}
                                                                onClick={ClickPreviewImage}
                                                            />
                                                        </div>
                                                        <div
                                                            className={styles.changeThumbButton}
                                                            onClick={ClickPreviewImage}
                                                        >
                                                            <img
                                                                alt="changeThumbnail"
                                                                src={require("../../../assets/image/thumnail.svg")}
                                                            />
                                                            <p className={styles.changeThumbIcon}>
                                                                サムネイルを変更
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <p className={styles.previewText}>
                                                        サムネイル画像を指定しない場合は、Videoから自動的にサムネイルが抽出されます
                                                    </p>
                                                </div>
                                            </>
                                        )}
                                        {visiblePreviewImage === 2 && (
                                            <div className={styles.form}>
                                                <label className={styles.uploadButton}>
                                                    <input
                                                        id="browserPhotoUploader"
                                                        ref={inputImageRef}
                                                        multiple
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={UserUploadImage}
                                                        className={styles.fileDisplay}
                                                    />
                                                    {textImageFile}
                                                </label>
                                            </div>
                                        )}
                                        {visiblePreviewImage === 3 && inputImageFile && (
                                            <div style={{ display: "flex" }}>
                                                <div className={styles.previewImage}>
                                                    <img
                                                        alt="thumbnail"
                                                        style={{ cursor: "pointer" }}
                                                        src={window.URL.createObjectURL(
                                                            inputImageFile
                                                        )}
                                                        onClick={ClickPreviewImage}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </li>

                                    {/* タグ（モーダル表示） */}
                                    <li className={styles.mb50} style={{ marginBottom: "15px" }}>
                                        <div className={styles.formHelperTextLong}>タグ</div>
                                        <div
                                            className={styles.formTag}
                                            style={{ marginBottom: "13px" }}
                                            onMouseEnter={() => setMouseEnterInfo(true)}
                                            onMouseLeave={() => setMouseEnterInfo(false)}
                                        >
                                            {!isMouseEnterInfo && (
                                                <img
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                    alt={"More"}
                                                    onClick={OpenTagSelectModal}
                                                    src={require("../../../assets/image/MoreIcon.svg")}
                                                />
                                            )}
                                            {isMouseEnterInfo && (
                                                <img
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                    alt={"More"}
                                                    onClick={OpenTagSelectModal}
                                                    src={require("../../../assets/image/MoreIcon_hover.svg")}
                                                />
                                            )}
                                        </div>
                                        <div className={styles.tags}>
                                            {tagList &&
                                                tagList.map((tag) => (
                                                    <Chip
                                                        label={tag}
                                                        key={tag}
                                                        color="secondary"
                                                        style={{
                                                            backgroundColor: "var(--studio-btn-bg)",
                                                        }}
                                                        size="medium"
                                                        className={styles.tag}
                                                        onDelete={handleDelete(tag)}
                                                    />
                                                ))}
                                        </div>
                                    </li>

                                    {/* 資料 */}
                                    <li>
                                        <div className={styles.formHelperTextLong}>資料</div>
                                        <div className={styles.documentIcon}>
                                            <UploadDocument
                                                alreadyUploadDocumentList={
                                                    alreadyUploadDocumentList
                                                        ? alreadyUploadDocumentList
                                                        : []
                                                }
                                                ChangeAlreadyUploadDocumentList={
                                                    ChangeAlreadyUploadDocumentList
                                                }
                                                ChangeDocumentList={ChangeDocumentList}
                                                documentList={documentList}
                                                ChangeDocumentNameList={ChangeDocumentNameList}
                                                documentNameList={documentNameList}
                                                ErrorDocumentListLength={ErrorDocumentListLength}
                                                setIsSaved={setIsSaved}
                                                isShowAddDocIcon={true}
                                            />
                                        </div>
                                    </li>
                                </ul>
                            </form>
                        </FormControl>
                        <li>
                            {/* 更新ボタン */}
                            <div className={styles.buttonGroup}>
                                {isInputAllForm && (
                                    <div className={styles.checkInput}>
                                        ※全ての項目を正しく入力してください
                                    </div>
                                )}
                                <Button
                                    type="submit"
                                    onClick={ClickDeleteButton}
                                    style={{
                                        marginRight: "16px",
                                        color: "#9C9C9C",
                                        fontFamily: "noto-sans-cjk-jp,sans-serif",
                                        border: "solid 2px #5D5D5D",
                                    }}
                                    className={styles.updateButton}
                                >
                                    ビデオを削除
                                </Button>
                                <Button
                                    type="submit"
                                    onClick={ClickConfirmButton}
                                    color="secondary"
                                    className={styles.updateButton}
                                    style={{
                                        color: "white",
                                        fontWeight: "bold",
                                        fontFamily: "noto-sans-cjk-jp,sans-serif",
                                        backgroundColor: "var(--studio-btn-bg)",
                                    }}
                                >
                                    更新
                                </Button>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>

            {/* アップロードファイルサイズチェック */}
            <PuiMessage
                open={isLimitInputFileSize}
                onClose={CloseLimitInputFileBar}
                type="error"
                title="1GB以上のファイルはアップロードできません"
                duration={5000}
            />

            {/* アップロードイメージサムネイルサイズチェック */}
            <PuiMessage
                open={isLimitInputImageSize}
                onClose={CloseLimitInputImageBar}
                type="error"
                title="10MB以上の画像はアップロードできません"
                duration={5000}
            />

            {/* アップロードファイルサイズチェック */}
            <PuiMessage
                open={isErrorInputSize}
                onClose={CloseErrorInputBar}
                type="error"
                title="正しいファイルを選択してください"
                duration={5000}
            />

            {/*------------------------ タグ編集モーダル ------------------------*/}
            <Modal open={isOpenTagSelectModal} onClose={CloseTagSelectModal}>
                <SelectTag
                    in={isOpenTagSelectModal}
                    onClose={CloseTagSelectModal}
                    tagList={tagList}
                    setTagList={setTagList}
                    setIsSaved={setIsSaved}
                />
            </Modal>

            {/*------------------------  グループ編集モーダル ------------------------*/}
            <Modal open={isOpenGroupSelectModal} onClose={CloseGroupSelectModal}>
                <SelectGroup
                    visibleModal={isOpenGroupSelectModal}
                    onClose={CloseGroupSelectModal}
                    targetName={inputVideoName}
                    userGroup={group}
                    SetGroupList={SetVideoGroup}
                    SetIsSaved={setIsSaved}
                />
            </Modal>

            {/*------------------------ 動画削除モーダル ------------------------*/}
            <Modal open={isOpenVerifyDeleteModal} onClose={CloseVerifyDeleteModal}>
                <div className={styles.verifyDeleteModal}>
                    <Button onClick={CloseVerifyDeleteModal} />
                    <ul className={styles.deleteModalUl}>
                        <div className={styles.deleteModalTitle}>対象のVideoを削除しますか?</div>
                        <li className={styles.deleteModalBtns}>
                            <Button
                                size="small"
                                variant="outlined"
                                color="secondary"
                                className={styles.verifyCancelButton}
                                onClick={ClickCancelDeleteUserButton}
                                style={{
                                    marginRight: "10px",
                                    color: "#9C9C9C",
                                    fontFamily: "noto-sans-cjk-jp,sans-serif",
                                    border: "solid 2px #5D5D5D",
                                }}
                            >
                                キャンセル
                            </Button>
                            <Button
                                size="small"
                                variant="outlined"
                                color="secondary"
                                className={styles.verifyDeleteButton}
                                onClick={ClickConfirmDeleteUserButton}
                                style={{
                                    color: "white",
                                    backgroundColor: "var(--studio-btn-bg)",
                                }}
                            >
                                削除
                            </Button>
                        </li>
                    </ul>
                </div>
            </Modal>

            {/*------------------------ ユーザ入力保存確認モーダル ------------------------*/}
            <OnLeaveDialog
                openDialog={openDialog}
                dialogTitle={"このページを移動しますか？"}
                dialogContent={"ページを移動すると、変更内容は失われます"}
                dialogActions={"ページ移動"}
                handleCloseDialog={handleCloseDialog}
                handleCancel={handleCancel}
                handleConfirm={handleConfirm}
            />
        </div>
    );
}

export default EditVideoPage;
